import * as React from 'react';
import * as styles from './agentBrandMainInfo.css';
import { mergeStyles } from '@cian/utils';
import * as PropTypes from 'prop-types';
import { HonestWork } from '@cian/honestwork-component';
import { OwnerBadge } from '@cian/owner-badge-component';

import { PartnerTooltip } from '../../../../components/PartnerTooltip';
import { EUserTrustLevel, IOffer } from '../../../../types/offer';
import { IconBlacklist, IconWhitelist } from '../../../../common/components/user-info-popup/icons';
import { IOfferHelper } from '../../../../presenter';
import { getIsFromBuilderFromContext } from '../../../../utils/suburban';
import { IUser } from '../../../../types/user';

interface IAgentBrandMainInfoContext {
  offer: IOffer;
  user: IUser | null;
  offerHelper: IOfferHelper;
  countrysideOffersBuilderBadge: boolean;
}

interface IAgentBrandMainInfoProps {
  isUsedOnTop3Card?: boolean;
}

const AgentBrandMainInfoComponent = (props: IAgentBrandMainInfoProps, context: IAgentBrandMainInfoContext) => {
  const userTrustLevel = context.offerHelper.presenters.getUserTrustLevel();
  const companyName = context.offerHelper.presenters.getCompanyName();
  const isFromBuilder = getIsFromBuilderFromContext(context);
  const isFromSeller = context.offerHelper.isFromSeller();
  const isLeadFactory = context.offerHelper.isLeadFactory();
  const isHomeownerVerified = context.offerHelper.isHomeownerVerified();
  const verifyWay = context.offerHelper.getVerifyWay();
  const userPersonalRating = context.offerHelper.presenters.getUserPersonalRating();
  const experienceString = context.offerHelper.presenters.getExperienceString();
  const { user, isPro, isPaid, isByHomeowner } = context.offer;
  const { isUsedOnTop3Card } = props;
  const masterAgent = user ? user.masterAgent : null;
  const name = context.offerHelper.presenters.getDisplayName();
  const agentAvatarUrl = context.offerHelper.presenters.getAvatarUrl();
  const isAgentUser = (!!context.user && context.user.isAgent) || false;
  const isCianPartner = !!(user && user.isCianPartner);

  return (
    <div>
      {agentAvatarUrl && !isPaid && (
        <img {...mergeStyles(styles['avatar'], !isUsedOnTop3Card && styles['avatar--premium'])} src={agentAvatarUrl} />
      )}

      <div className={styles['badge-container']}>
        {userTrustLevel === EUserTrustLevel.Involved && (
          <div onClick={e => e.stopPropagation()} className={styles['badge']}>
            <HonestWork />
          </div>
        )}

        {isFromBuilder && !isLeadFactory && (
          <div {...mergeStyles([styles['badge'], styles['text-badge'], styles['green']])}>Застройщик</div>
        )}

        {!isFromBuilder && isFromSeller && !isLeadFactory && (
          <div {...mergeStyles([styles['badge'], styles['text-badge'], styles['green']])}>
            Представитель
            <br />
            застройщика
          </div>
        )}

        {isAgentUser && isPro && !(isFromBuilder || isFromSeller) && (
          <div {...mergeStyles([styles['badge'], styles['text-badge']])}>PRO</div>
        )}

        {isByHomeowner && (
          <span className={styles['owner-badge-wrapper']}>
            <OwnerBadge isVerified={isHomeownerVerified} verifyWay={verifyWay} />
          </span>
        )}

        {isCianPartner && (
          <PartnerTooltip
            master={<div {...mergeStyles([styles['badge'], styles['text-badge'], styles['green']])}>Партнёр</div>}
          />
        )}

        {userPersonalRating === 'positive' && (
          <div>
            <IconWhitelist isActive />
          </div>
        )}

        {userPersonalRating === 'negative' && (
          <div>
            <IconBlacklist isActive />
          </div>
        )}
      </div>

      <div className={styles['name']}>{name}</div>

      {companyName && !masterAgent && <div className={styles['company-name']}>{companyName}</div>}

      {experienceString && isUsedOnTop3Card && <div className={styles['experience']}>{experienceString}</div>}
    </div>
  );
};

AgentBrandMainInfoComponent.contextTypes = {
  offer: PropTypes.object,
  user: PropTypes.object,
  offerHelper: PropTypes.object,
  countrysideOffersBuilderBadge: PropTypes.bool,
};

export const AgentBrandMainInfo = AgentBrandMainInfoComponent;
